/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierRepInformation
 */
export interface CarrierRepInformation {
  /**
   *
   * @type {string}
   * @memberof CarrierRepInformation
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CarrierRepInformation
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof CarrierRepInformation
   */
  phoneNumber: string;
}

/**
 * Check if a given object implements the CarrierRepInformation interface.
 */
export function instanceOfCarrierRepInformation(
  value: object,
): value is CarrierRepInformation {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("email" in value) || value["email"] === undefined) return false;
  if (!("phoneNumber" in value) || value["phoneNumber"] === undefined)
    return false;
  return true;
}

export function CarrierRepInformationFromJSON(
  json: any,
): CarrierRepInformation {
  return CarrierRepInformationFromJSONTyped(json, false);
}

export function CarrierRepInformationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierRepInformation {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    email: json["email"],
    phoneNumber: json["phoneNumber"],
  };
}

export function CarrierRepInformationToJSON(json: any): CarrierRepInformation {
  return CarrierRepInformationToJSONTyped(json, false);
}

export function CarrierRepInformationToJSONTyped(
  value?: CarrierRepInformation | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    email: value["email"],
    phoneNumber: value["phoneNumber"],
  };
}
